import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function Image({ highQualitySrc, lowQualitySrc, alt, className, ...props }) {
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);

    return (
        <div className={`relative ${className || ""}`}>
            {/* Loading skeleton */}
            {!isLoaded && !hasError && (
                <div className="absolute inset-0 bg-gray-200 animate-pulse" />
            )}
            <LazyLoadImage
                src={highQualitySrc}
                placeholderSrc={lowQualitySrc}
                alt={alt}
                effect="blur"
                threshold={300}
                afterLoad={() => setIsLoaded(true)}
                onError={() => setHasError(true)}
                loading="lazy"
                decoding="async"
                {...props}
            />
        </div>
    );
}

export default Image;
